var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowSelectDown = function SvgArrowSelectDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 5,
    fill: "currentColor",
    style: {
      color: "#fff",
      marginTop: "-3px",
      marginLeft: "-6px",
      position: "absolute"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.922.244a.833.833 0 0 0-1.178 0L5 2.988 2.256.244a.833.833 0 1 0-1.179 1.179l3.334 3.333a.833.833 0 0 0 1.178 0l3.333-3.333a.833.833 0 0 0 0-1.179Z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowSelectDown;